import styled from 'styled-components';
import { applyTrackingId } from '../../AnalyticsContext/applyTrackingId';
import { renderLinkTrackingAttributes } from '../../AnalyticsContext/renderLinkTrackingAttributes';
import { PropsOf } from '../../util/PropsOf';
import {
  ButtonStyleProps,
  constantButtonStyles,
  getBackgroundColor,
  getBorderStyle,
  getTextColor,
  getSizing,
} from './Button.styles';
import { ButtonCompartments } from './ButtonCompartments';
import { ButtonProps } from './constants';

export type Props = ButtonProps & PropsOf<typeof ButtonView>;

export const ButtonView = styled.button<ButtonStyleProps>`
  ${constantButtonStyles};
  ${getBorderStyle};
  ${getTextColor};
  ${getBackgroundColor};
  ${getSizing}
`;

export const Button = ({
  leftContent,
  children,
  rightContent,
  trackingData: clickTracking,
  trackingId,
  ...viewProps
}: Props) => {
  const clickTrackingAttributes = renderLinkTrackingAttributes(clickTracking);
  const trackingIdProps = applyTrackingId(trackingId);

  return (
    <ButtonView {...viewProps} {...clickTrackingAttributes} {...trackingIdProps}>
      <ButtonCompartments
        leftContent={leftContent}
        rightContent={rightContent}
        options={viewProps.options}
      >
        {children}
      </ButtonCompartments>
    </ButtonView>
  );
};
